import Vue from 'vue'
import VueI18n from 'vue-i18n'
import locale from 'element-ui/lib/locale'
import zh from './zh.js'
import en from './en.js'
import lo from './lo.js'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import enLocale from 'element-ui/lib/locale/lang/en'

Vue.version = '2.6.14'
Vue.use(VueI18n)

const messages = {
  zh: Object.assign(zh, zhLocale),
  en: Object.assign(en, enLocale),
  lo: Object.assign(lo, enLocale),
}
//将vuei18n实例化，并传入配置信息
const i18n = new VueI18n({
  locale: localStorage.getItem('locale') || 'zh', //当前语种，locale用来设置语种包
  messages,  //本地语言包
  fallbackLocale: 'zh', //当前语种不存在时，默认设置当前语种为中文
  numberFormats:{ //设置数字格式化
    'en': {
      currency: { 
        style: 'currency', currency: 'USD'
      }
    },
    'lo': {
      currency: { 
        style: 'currency', currency: 'USD'
      }
    },
    'zh': {
      currency: {
        style: 'currency', currency: 'JPY', currencyDisplay: 'symbol'
      }
    }
  },
  dateTimeFormats:{//设置日期时间格式化
    'en': {
      short: { //显示英文 年月日
        year: 'numeric', month: 'short', day: 'numeric'
      },
      long: { //显示英文 年月日 星期 小时 分钟
        year: 'numeric', month: 'short', day: 'numeric',
        weekday: 'short', hour: 'numeric', minute: 'numeric'
      }
    },
    'lo': {
      short: { //显示英文 年月日
        year: 'numeric', month: 'short', day: 'numeric'
      },
      long: { //显示英文 年月日 星期 小时 分钟
        year: 'numeric', month: 'short', day: 'numeric',
        weekday: 'short', hour: 'numeric', minute: 'numeric'
      }
    },
    'zh': {
      short: {
        year: 'numeric', month: 'short', day: 'numeric'
      },
      long: {
            year: 'numeric', month: 'short', day: 'numeric',
            weekday: 'short', hour: 'numeric', minute: 'numeric'  
      }
    }
  }
})
window.i18n = i18n;
locale.i18n((key, value) => i18n.t(key, value)) //为了实现element插件的多语言切换

export default i18n
